import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './ui-library.page.html',
  styleUrls: ['./ui-library.page.scss', '/src/assets/css/hotfix.scss']
})
export class UILibraryPage {

}
